import i18n from "i18n";

// Locale Intl par langue de l'interface.
// ar : chiffres latins (nu-latn) pour rester cohérent avec téléphones, heures et saisies.
const LOCALES = {
  fr: "fr-FR",
  ar: "ar-u-nu-latn",
  en: "en-GB",
};

// Formats prédéfinis (options Intl.DateTimeFormat)
export const FORMATS = {
  court: { day: "2-digit", month: "2-digit", year: "numeric" }, // 01/11/2026
  long: { weekday: "long", day: "numeric", month: "long", year: "numeric" }, // dimanche 1 novembre 2026
  dateHeure: { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" },
  jourCourt: { weekday: "short", day: "numeric", month: "short" }, // dim. 1 nov.
  mois: { month: "short" }, // nov.
  moisAnnee: { month: "long", year: "numeric" }, // novembre 2026
};

export const localeDe = (lng) => LOCALES[(lng || "").split("-")[0]] || LOCALES.fr;

// "2026-11-01" est lu comme minuit UTC par new Date() → on le lit en heure locale
// pour ne jamais décaler la date d'un jour.
function versDate(d) {
  if (d instanceof Date) return d;
  if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
    const [y, m, j] = d.split("-").map(Number);
    return new Date(y, m - 1, j);
  }
  return new Date(d);
}

/**
 * formatDate(d, lng, format)
 * - d : Date, chaîne ISO ("2026-11-01" ou "2026-11-01T18:00:00Z") ou timestamp
 * - lng : "fr" | "ar" | "en" (défaut : langue courante de i18next)
 * - format : clé de FORMATS (défaut "court") ou objet d'options Intl
 * Retourne "" si la date est absente ou invalide.
 */
export function formatDate(d, lng, format = "court") {
  if (d === null || d === undefined || d === "") return "";
  const date = versDate(d);
  if (Number.isNaN(date.getTime())) return "";
  const options = typeof format === "string" ? FORMATS[format] || FORMATS.court : format;
  return new Intl.DateTimeFormat(localeDe(lng || i18n.language), options).format(date);
}

export default formatDate;
